module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_6_3.fa21c148.jpeg";